/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { GsptComponent } from './gspt.component';
import { GsptDialogComponent } from './gspt-dialog.component';
import { SharedModule } from '../../modules/shared/shared.module';
import { GsptService } from './gspt.service';

@NgModule({
    declarations: [
        GsptComponent,
        GsptDialogComponent,
    ],
    exports: [
        GsptComponent,
    ],
    imports: [
        SharedModule,
    ],
})
export class GsptModule {
}
